import { render, staticRenderFns } from "./Search_Loads.vue?vue&type=template&id=25026366&"
import script from "./Search_Loads.vue?vue&type=script&lang=ts&"
export * from "./Search_Loads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports